import {
  SHOW_HEADER,
  CLOSE_SIDE_MENU,
  SHOW_SITEMAP_OVERLAY,
  HIDE_SITEMAP_OVERLAY,
  SHOW_WECHAT_OVERLAY,
  HIDE_WECHAT_OVERLAY
} from '@/store/mutation-types'

export default {
  state: {
    sitemap: {
      isShown: false
    },
    wechat: {
      isShown: false
    }
  },
  mutations: {
    [SHOW_SITEMAP_OVERLAY] (state) {
      state.sitemap.isShown = true
    },
    [HIDE_SITEMAP_OVERLAY] (state) {
      state.sitemap.isShown = false
    },
    [SHOW_WECHAT_OVERLAY] (state) {
      state.wechat.isShown = true
    },
    [HIDE_WECHAT_OVERLAY] (state) {
      state.wechat.isShown = false
    }
  },
  getters: {
    hasOverlays (state) {
      return state.sitemap.isShown || state.wechat.isShown
    }
  },
  actions: {
    hideOverlays ({ dispatch }) {
      dispatch('hideSitemapOverlay')
      dispatch('hideWechatOverlay')
    },
    showSitemapOverlay ({ state, commit }) {
      commit(CLOSE_SIDE_MENU)
      commit(SHOW_HEADER)

      if (!state.sitemap.isShown) {
        commit(SHOW_SITEMAP_OVERLAY)
      }
    },
    hideSitemapOverlay ({ state, commit }) {
      if (state.sitemap.isShown) {
        commit(HIDE_SITEMAP_OVERLAY)
      }
    },
    toggleSitemapOverlay ({ state, dispatch }) {
      dispatch(!state.sitemap.isShown ? 'showSitemapOverlay' : 'hideSitemapOverlay')
    },
    showWechatOverlay ({ state, commit }) {
      commit(CLOSE_SIDE_MENU)
      commit(SHOW_HEADER)

      if (!state.wechat.isShown) {
        commit(SHOW_WECHAT_OVERLAY)
      }
    },
    hideWechatOverlay ({ state, commit }) {
      if (state.wechat.isShown) {
        commit(HIDE_WECHAT_OVERLAY)
      }
    },
    toggleWechatOverlay ({ state, dispatch }) {
      dispatch(!state.sitemap.isShown ? 'showWechatOverlay' : 'hideWechatOverlay')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/overlays.js